import React, { useRef, useEffect } from "react";
import "./AssociatedWith.css";

const associated = [
  "/logos/startupindia.png", "/logos/govt.png", "/logos/thub.png",
  "/logos/wen.png", "/logos/aic_raise.png", "/logos/dpiit.png",
  "/logos/ashaer.jpg", "/logos/kalwings.png", "/logos/tsic.png",
  "/logos/niti.png", "/logos/samaritans.png",
  "/logos/learncbse.png", "/logos/aicte.png", "/logos/commerce.png",
  "/logos/it.png", "/logos/virtual.png", "/logos/iot.png",
  "/logos/code_to_change.png", "/logos/gradrise.png",
];

const loopLogos = [...associated, ...associated];

const AssociatedWith = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("fade-up");
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} className="associated-section animate-section">
      <h2 className="collab-heading1 mt-5 mb-3">We Associated With</h2>
      <div className="scroll-container scroll-right">
        <div className="scroll-track mt-4">
          {loopLogos.map((src, i) => (
            <img key={i} src={src} alt={`logo-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AssociatedWith;
